import { take, call, put} from 'redux-saga/effects';
import {
	getUserList,
	failGetUserList,
	successGetUserList,
	getJigyoshaList,
	failGetJigyoshaList,
	successGetJigyoshaList,
	getDenpyoYoshikiList,
	failGetDenpyoYoshikiList,
	successGetDenpyoYoshikiList,
	getKeiyakuKigyouList,
	failGetKeiyakuKigyouList,
	successGetKeiyakuKigyouList,
	getAsnCorporateList,
	failGetAsnCorporateList,
	successGetAsnCorporateList,
	getTrHenkanList,
	failGetTrHenkanList,
	successGetTrHenkanList,
	getAsnHenkanList,
	failGetAsnHenkanList,
	successGetAsnHenkanList,
	getAsnList,
	failGetAsnList,
	successGetAsnList,
	getASNRenkeiList,
	failGetASNRenkeiList,
	successGetASNRenkeiList,
	getHasonhoukokuKbnList,
	failGetHasonhoukokuKbnList,
	successGetHasonhoukokuKbnList,
} from '../../actions';
import superFetch from '../../modules/superFetch';
import {getApiUrl} from "./../index";

export function* handleGetUserList() {
	while (true) {
		const action = yield take(`${getUserList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-user-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetUserList({err:msg}));
			continue;
		}
		yield put(successGetUserList(Object.assign({}, payload, {})));
	}
}

export function* handleGetJigyoshaList() {
	while (true) {
		const action = yield take(`${getJigyoshaList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-jigyousha-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetJigyoshaList({err:msg}));
			continue;
		}
		yield put(successGetJigyoshaList(Object.assign({}, payload, {})));
	}
}


export function* handleGetDenpyoYoshikiList() {
	while (true) {
		const action = yield take(`${getDenpyoYoshikiList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-denpyo-yoshiki-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetDenpyoYoshikiList({err:msg}));
			continue;
		}
		yield put(successGetDenpyoYoshikiList(Object.assign({}, payload, {})));
	}
}

export function* handleGetKeiyakuKigyouList() {
	while (true) {
		const action = yield take(`${getKeiyakuKigyouList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-keiyakukigyou-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetKeiyakuKigyouList({err:msg}));
			continue;
		}
		yield put(successGetKeiyakuKigyouList(Object.assign({}, payload, {})));
	}
}
export function* handleGetAsnCorporateList() {
	while (true) {
		const action = yield take(`${getAsnCorporateList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-asn-corporate-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetAsnCorporateList({err:msg}));
			continue;
		}
		yield put(successGetAsnCorporateList(Object.assign({}, payload, {})));
	}
}

export function* handleGetTrHenkanList() {
	while (true) {
		const action = yield take(`${getTrHenkanList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-tr-henkan-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetTrHenkanList({err:msg}));
			continue;
		}
		yield put(successGetTrHenkanList(Object.assign({}, payload, {})));
	}
}

export function* handleGetASNRenkeiList() {
	while (true) {
		const action = yield take(`${getASNRenkeiList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-asn-renkei-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetASNRenkeiList({err:msg}));
			continue;
		}
		yield put(successGetASNRenkeiList(Object.assign({}, payload, {})));
	}
}
export function* handleGetAsnHenkanList() {
	while (true) {
		const action = yield take(`${getAsnHenkanList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-asn-henkan-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetAsnHenkanList({err:msg}));
			continue;
		}
		yield put(successGetAsnHenkanList(Object.assign({}, payload, {})));
	}
}

export function* handleGetAsnList() {
	while (true) {
		const action = yield take(`${getAsnList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-asn-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetAsnList({err:msg}));
			continue;
		}
		yield put(successGetAsnList(Object.assign({}, payload, {})));
	}
}

export function* handleGetHasonhoukokuKbnList() {
	while (true) {
		const action = yield take(`${getHasonhoukokuKbnList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'master/get-hasonhoukoku-kbn-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetHasonhoukokuKbnList({err:msg}));
			continue;
		}
		yield put(successGetHasonhoukokuKbnList(Object.assign({}, payload, {})));
	}
}



// WEBPACK FOOTER //
// ./src/sagas/master/common.js